// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__2hUzL","header":"PatientBlock_header__28zcc","label":"PatientBlock_label__1Wshk","option":"PatientBlock_option__3BjUV"};